import API from 'utils/api';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/tabulador-de-valores-vehiculares/';

/**
 * GET Tabuladores Vehiculares
 * @param {object} params
 * @returns {Promise<object>}
 */
export const getTabuladoresVehiculares = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return { ...response.data, results: formatReceived(response.data.results) };
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Tabulador Vehicular
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTabuladorVehicular = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tabulador Vehicular
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTabuladorVehicular = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Terminal de NetPay
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTabuladorVehicular = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tabulador Vehicular
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTabuladorVehicular = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
